<template>
  <div>

    <page-heading-info
    title="Jefferson County Court of Common Pleas"
    courthouse="true"
    ></page-heading-info>

    <div class="row">
      <div class="col-md-6">
        <text-box-title title="Judge Joseph J. Bruzzese, Jr.">
        
          <div class="col-12 ml-3">
            <address-simple
            line1="Jefferson County Courthouse"
            line2="301 Market Street"
            line3="Second Floor"
            line4="Steubenville, OH 43952"
            phone="(740) 283-8543"
            class="mt-3"
            ></address-simple>
          </div>
        
        </text-box-title>
      </div>

      <div class="col-md-6">
        <text-box-title title="Judge Michelle G. Miller">
    
          <div class="col-12 ml-3">
            <address-simple
            line1="Jefferson County Courthouse"
            line2="301 Market Street"
            line3="Third Floor"
            line4="Steubenville, OH 43952"
            phone="(740) 283-8545"
            class="mt-3"
            ></address-simple>
          </div>
        
        </text-box-title>
      </div>
    </div>

    <text-box-title title="General Info">

      <div class="col-md-6 mt-3">
        <text-box-title
          title=""
          icon=""
          align="left"
          block="true"
          title-bg="warning-02"
          class="padding-bootstrap mb-4">
          
            <div class="col">
              <div class="mb-3">
                Due to the COVID-19 virus, anyone entering the court is now required by the state to wear 
                a face mask. Please contact this court if you have any questions.
              </div>
            </div>

        </text-box-title>

        Jurisdiction includes all civil matters exceeding $500.00, domestic-divorces and dissolution cases, and criminal felonies.
      </div>
      
      <div class="col-md-6 mt-3">
        <link-box
        bg-color="dark"
        dark="true"
        icon="payment"
        icon-color="light"
        title-color="light"
        title="Court Case Lookup"
        title-align="left"
        url="https://eservices.jeffersoncountyoh.com">
          Look up common pleas court cases
        </link-box>
      </div>
    </text-box-title>

    <text-box-title title="Rules of Court">
      <note-documents note-id="19" class="ml-3 mr-3 mt-3"></note-documents>
    </text-box-title>

  </div>
</template>

<script>
import PageHeadingInfo from '@/components/layout/PageHeadingInfo.vue'
import OfficeInfo from '@/components/layout/OfficeInfo.vue'
import TextBoxTitle from '@/components/layout/TextBoxTitle.vue'
import LinkBox from '@/components/layout/LinkBox.vue'
import NoteText from '@/components/display-utils/NoteText.vue'
import NoteDocuments from '@/components/display-utils/NoteDocuments.vue'
import AddressSimple from '@/components/display-utils/AddressSimple.vue'

export default {
  components: {
    PageHeadingInfo,
    OfficeInfo,
    TextBoxTitle,
    LinkBox,
    NoteText,
    NoteDocuments,
    AddressSimple
  },
  data () {
    return {}
  }
}
</script>

<style scoped>
  .image-max {
    max-width: 350px;
  }

  .court-lookup {
    font-size: 1.5em;
    font-weight: bold;
  }

  .court-lookup:hover {
    opacity: 0.7;
  }

</style>
